import { callServiceLight, getState } from "./dataService";
import { RuntimeContext } from "./NGFieldExtensions";

async function GetPlatformVersion(context: RuntimeContext) {
  const platformInfo = await callServiceLight({ Name: "releaseinfo.get.application", Service: "releaseinfo.get.application" }, {}, context)
  if (!platformInfo?.success) {
    return null;
  }
  return platformInfo?.data;
}

async function GetMetadataVersion(context: RuntimeContext) {
  const metadataInfo = await callServiceLight({ Name: "releaseinfo.get.metadata", Service: "releaseinfo.get.metadata" }, {}, context)
  if (!metadataInfo?.success) {
    return null;
  }
  return metadataInfo?.data;
}

function GetSDKVersion() {
  return {
    BranchName: import.meta.env.VITE_GIT_BRANCH,
    CommitSha: import.meta.env.VITE_GIT_COMMIT_SHA,
  }
}


async function GetReleaseInfoState(context: RuntimeContext) {
  const { global } = getState(context);
  const releaseInfo = {
    ATier: await GetPlatformVersion(context),
    PTier: await GetMetadataVersion(context),
    SDKTier: GetSDKVersion(),
  };
  global["ReleaseInfo"].value = releaseInfo;
  return releaseInfo;
}

export {
  GetMetadataVersion,
  GetPlatformVersion,
  GetReleaseInfoState,
  GetSDKVersion
}